import { useState } from "react";
import { useNavigate } from "react-router-dom";
import { Modal, notification, Pagination, Table } from "antd";

import { Button, DotBtn } from "components";
import { useHooks, useDebounce, usePost } from "hooks";
import Container from "modules/container";
import Fields from "components/fields";

const Banner = () => {
  const { t, qs, get, location, queryClient } = useHooks();
  const { mutate } = usePost();
  const [page, setPage] = useState<number>(1);
  const [query, setQuery] = useState("");
  const searchQuery = useDebounce(query, 600);

  const params = qs.parse(location.search, { ignoreQueryPrefix: true });
  const navigate = useNavigate();

  const onDeleteHandlerBanner = (row: any) => {
    const id = get(row, "_id");
    Modal.confirm({
      title: t("Productni o'chirishni tasdiqlaysizmi") + "?",
      cancelText: t("yo'q"),
      okType: "primary",
      okText: t("ha"),
      onOk: () => deleteActionBanner(id),
    });
  };

  const deleteActionBanner = (id: any) => {
    if (id) {
      mutate(
        { method: "delete", url: `banner/${id}`, data: null },
        {
          onSuccess: () => {
            queryClient.invalidateQueries({
              queryKey: [`banner`],
            });

            notification["success"]({
              message: t("Успешно удален!"),
              duration: 2,
            });
          },
          onError: (error: any) => {
            notification["error"]({
              message: t(
                get(error, "response.data.error", "Произошло ошибка!")
              ),
              duration: get(error, "response.data.message") ? 4 : 2,
            });
          },
        }
      );
    }
  };

  return (
    <>
      <div className="content-panel">
        <div>
          <Container.All
            url="banner"
            name="banner"
            params={{
              limit: 15,
              page,
              extra: {
                search: searchQuery,
                start: params.start && params.start,
                end: params.end && params.end,
              },
            }}
          >
            {({ meta, items }) => {
              return (
                <div>
                  <div className="page-heading">
                    <p className="page-heading__title">
                      {t("Bannerlar")}
                      <p className="page-heading__subtitle">
                        {t("Bannerlar soni")}: {get(meta, "totalCount")}
                      </p>
                    </p>
                    <div className="page-heading__right">
                      <Button
                        type="primary"
                        title="O'zgartirish"
                        create
                        onClick={() => navigate("/banner/update")}
                      />
                    </div>
                  </div>
                  <Table
                    dataSource={items}
                    pagination={false}
                    columns={[
                      {
                        key: "id",
                        title: t("№"),
                        align: "left",
                        dataIndex: "_id",
                        className: "w-[20px]",
                        render: (value) => <>{value}</>,
                      },
                      {
                        key: "type",
                        title: t("Nomi va rasmi"),
                        align: "left",
                        dataIndex: "color",
                        className: "w-[220px]",
                        render: (value, row) => {
                          const name = get(row, "type", "Noma’lum");
                          const photos: { url?: string }[] = get(
                            row,
                            "images",
                            []
                          );
                          return (
                            <div className="flex items-center gap-2">
                              <div className="flex mr-2">
                                {Array.isArray(photos) &&
                                  photos.map((photo, index) =>
                                    typeof photo === "object" && photo?.url ? (
                                      <div
                                        key={index}
                                        className={`relative ${
                                          index !== 0 ? "-ml-3" : ""
                                        }`}
                                      >
                                        <img
                                          src={photo.url}
                                          className="w-[44px] h-[44px] rounded-lg object-cover border-2 border-white"
                                          alt="product"
                                        />
                                      </div>
                                    ) : null
                                  )}
                              </div>
                              <span>{name}</span>
                            </div>
                          );
                        },
                      },
                      {
                        title: t("Amallar"),
                        align: "center",
                        className: "w-[1px]",
                        render: (value, row) => (
                          <DotBtn
                            row={row}
                            editFunction={() => navigate(`/banner/update`)}
                            deleteFunction={() => onDeleteHandlerBanner(row)}
                          />
                        ),
                      },
                    ]}
                  />
                  {meta && meta.perPage && (
                    <div className="pt-[20px] flex justify-end">
                      <Pagination
                        current={meta.currentPage}
                        pageSize={meta.perPage}
                        total={meta.totalCount}
                        onChange={setPage}
                      />
                    </div>
                  )}
                </div>
              );
            }}
          </Container.All>
        </div>
      </div>
    </>
  );
};

export default Banner;
